import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from '@app/common/global_variables';
import { EditComponent } from '@app/common/templates/edit/edit.component';
import { AccountService } from '@app/services/account.service';
import { CRUDService } from '@app/services/crud.service';
import PATH from '@assets/routes/routes.json';
import { BreadcrumbService } from '@components/breadcrumb.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
	templateUrl: '../../../../common/templates/edit/edit.component.html',
	styleUrls: ['../style.scss', '../../../../common/templates/edit/style.scss'],
	providers: [DialogService, MessageService, ConfirmationService]
})
export class TblFahrzeugAkteKomponenteLinkEditComponent extends EditComponent {
	constructor(
		public accountService: AccountService,
		public breadcrumbService: BreadcrumbService,
		public confirmationService: ConfirmationService,
		public crudService: CRUDService,
		public dialogService: DialogService,
		public globals: Globals,
		public messageService: MessageService,
		public router: Router,
		public translate: TranslateService,
	) {
		super(accountService, breadcrumbService, confirmationService, crudService, dialogService, globals, messageService, router, translate);

		this.apiUrl = 'TblFahrzeugAkteKomponenteLink';
		this.name = 'MENU.FAHRZEUGAKTE_KOMPONENTE_LINK';
		this.url = '/' + PATH.FAHRZEUGAKTE_KOMPONENTE_LINK;
		this.fieldgroups.push(
			[
				{ type: 'text', key: 'ankey', required: true, width: 400 },
				{ type: 'object_readonly', key: 'FREMD_fahrzeug_ankey', required: false, width: 400, url: '/' + PATH.FAHRZEUG, id: 'FREMD_fahrzeug_id' },
				{ type: 'object_readonly', key: 'FREMD_fahrzeug_kennzeichen', required: false, width: 400, url: '/' + PATH.FAHRZEUG, id: 'FREMD_fahrzeug_id' },
				{ type: 'object_readonly', key: 'FREMD_fahrzeug_bezeichnung', required: false, width: 400, url: '/' + PATH.FAHRZEUG, id: 'FREMD_fahrzeug_id' },
				{ type: 'text_readonly', key: 'FREMD_fahrzeug_logbox_serial', required: false, width: 400, readonly: true },
				{ type: 'object_readonly', key: 'FREMD_komponente_ankey', required: false, width: 400, url: '/' + PATH.KOMPONENTE, id: 'komponente_id' },
				{ type: 'object_readonly', key: 'FREMD_komponente_bezeichnung', required: false, width: 400, url: '/' + PATH.KOMPONENTE, id: 'komponente_id' },
				{ type: 'text_readonly', key: 'FREMD_komponente_bemerkungen', required: false, width: 400, readonly: true },
				{ type: 'object_readonly', key: 'FREMD_komponente_typ_ankey', required: false, width: 400, url: '/' + PATH.KOMPONENTE_TYP, id: 'FREMD_komponente_typ_id' },
				{ type: 'object_readonly', key: 'FREMD_komponente_typ_bezeichnung', required: false, width: 400, url: '/' + PATH.KOMPONENTE_TYP, id: 'FREMD_komponente_typ_id' },
				{ type: 'date', key: 'zugeordnet_von_date', required: false, width: 400, dateonly: true },
				{ type: 'date', key: 'zugeordnet_bis_date', required: false, width: 400, dateonly: true },
				{ type: 'text', key: 'bemerkungen', required: false, width: 400 },
			]
		);
		this.breadcrumbService.setItems([
			{ label: 'MENU.STAMMDATEN' },
			{ label: this.name, routerLink: [this.url] },
			{ label: 'BREADCRUMBS.EDIT', routerLink: [this.url + '/' + PATH.EDIT + '/' + this.id] }
		]);
	}
}
